module.exports = __webpack_public_path__ + "img/documentation-1.f1a29342.png";